export const AUTH_STATUS = 'authStatus';
export const AUTH_TOKEN = 'authToken';
export const USER_ID = 'userId';
export const USER_ROLE = 'userRole';
export const USER_NAME = 'userName';
export const USER_EMAIL = 'userEmail';
export const USER_PHONE = 'userPhone';